<div class="user-cards-container d-block d-md-none" [class.show-list]="showList">
    <div class="header-container">
        <div class="search-container">
            <div class="d-flex justify-content-between align-items-center">
                <div class="flex-grow-1 me-2">
                    <app-custom-search
                        placeholderText="{{ 'directory.pages.members.searchByPlaceholder' | translate }}"
                        customSearchName="filterUserByName"
                        [userInput]="searchText"
                        (searchTextChanged)="onSearchTextChanged($event)"
                    >
                    </app-custom-search>
                </div>
                <button
                    type="button"
                    class="btn btn-primary d-flex align-items-center justify-content-center p-0"
                    style="width: 38px; height: 38px"
                    (click)="onClose()"
                >
                    <i class="icon icon-close"></i>
                </button>
            </div>
        </div>
    </div>

    <div class="users-container" *ngIf="users && users.length > 0">
        <app-infinite-scroll (scrolled)="onScroll()">
            <div class="mobile-info-card" *ngFor="let profile of users">
                <app-user-directory-profile-card
                    [profile]="profile"
                    [isAdminProfile]="false"
                    [isActive]="activeUserId === profile.userId"
                    (cardClick)="onUserSelected(profile.userId)"
                    [attr.data-user-id]="profile.userId"
                >
                </app-user-directory-profile-card>
            </div>
        </app-infinite-scroll>
    </div>

    <div *ngIf="isLoading || users.length == 0" class="text-center d-flex justify-content-center py-3 w-100">
        <div class="spinner-border text-info" role="status">
            <span class="sr-only">"{{ 'directory.pages.members.loadingMessage' | translate }}"</span>
        </div>
    </div>
</div>
